import script from "./SMSCampaignsPeriod.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsPeriod.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsPeriod.vue?vue&type=style&index=0&id=61a38756&lang=scss"

const __exports__ = script;

export default __exports__